// 🎵 Miko's Arcade — Canonical music registry (Feb 2026 owner drop).
// Each entry maps a stage / hero / mode to an audio track. Tracks are
// hosted on the Emergent asset CDN — do not copy locally or the license
// path could drift. Add/replace tracks here only.

export const ARCADE_MUSIC = {
  // Boss battle theme played while the beat-'em-up canvas is active
  // (Area 1 · The Scrap Yards). Loops.
  pocket_world_battle: {
    id:    "boss_battle_breakout",
    label: "Boss Battle Breakout",
    url:   "https://customer-assets-rejwkqb3.emergentagent.net/job_omni-brand-1/artifacts/yya50eyd_boss_battle_breakout.mp4",
    loop:  true,
    volume: 0.5,
    canon: "Feb 2026 owner drop · plays while inside Miko's pocket world",
  },
  // 🏭 Area 2 · The Automated Assembly Line stage BGM (Feb 9, 2026).
  // Ambient in combat zones, swells louder during the Assembler boss.
  // Auto-swaps in when the player crosses into Area 2 (x >= 3200).
  clockwork_ballet: {
    id:    "clockwork_ballet",
    label: "Clockwork Ballet",
    url:   "https://customer-assets-rejwkqb3.emergentagent.net/job_omni-brand-1/artifacts/a1hn43eu_clockwork_ballet.mp4",
    loop:  true,
    volume: 0.5,
    scope: "miko_arcade",
    area:  2,
    canon: "Feb 9, 2026 owner drop · Area 2 ambient stage BGM (swells at boss)",
  },
  // Glitch's signature stage theme in Dragonious Fighters (1-on-1).
  // ⚠️ Dragonious Fighters engine is NOT built yet — parked until the
  // character-select + stage-loader ships. Owner canon Feb 2026:
  // Glitch's stage song IS Dragonious Fighters. Not Miko Arcade.
  glitch_aurora_borealis_dragonious_stage: {
    id:    "limestone_and_light",
    label: "Limestone and Light",
    url:   "https://customer-assets-rejwkqb3.emergentagent.net/job_omni-brand-1/artifacts/a9ye6150_limestone_and_light.mp4",
    loop:  true,
    volume: 0.5,
    scope: "dragonious_fighters",
    stage: "glitch_aurora_borealis_stage",
    canon: "Feb 2026 owner drop · Glitch 🌌 stage theme in Dragonious Fighters (Aurora Borealis venue)",
  },
  // Deanah & Muki's stage theme in Dragonious Fighters (1-on-1 fighter).
  // ⚠️ Dragonious Fighters engine is NOT built yet — this is parked
  // until the character-select + stage-loader ships. Owner canon
  // Feb 2026: "Deanah music is Dragonious Fighters her theme song on
  // her stage." Not a Miko Arcade / RPG track.
  deanah_muki_dragonious_stage_theme: {
    id:    "schematics_of_the_heart",
    label: "Schematics of the Heart",
    url:   "https://customer-assets-rejwkqb3.emergentagent.net/job_omni-brand-1/artifacts/e59udqu5_schematics_of_the_heart.mp4",
    loop:  true,
    volume: 0.5,
    scope: "dragonious_fighters",
    stage: "deanah_muki_stage",
    canon: "Feb 2026 owner drop · Deanah 👩🏿‍💻 & Muki 🐾 stage theme in Dragonious Fighters (1-on-1 fighter)",
  },
};
